export default __webpack_public_path__ + "static/steier-9617e871bde25c45ee99fb3e4914ca42.jpg";